import NotUnsafeSuccess from "../../Components/NotUnsafe/NotUnsafeSuccess";

const TransferNotUnsafeSuccess = () => {
    return <NotUnsafeSuccess />;
}
 
export default TransferNotUnsafeSuccess;